import React from "react";
import OwTranslate from "../OwTranslate/OwTranslate";

type Props = {
    inputString: string | undefined;
    maxLength?: number;
    showCharLabel?: boolean;
    className?: string;
};

export const OwCharCount: React.FC<Props> = (props) => {
    let currentLength = 0;

    if (props.inputString) {
        currentLength = props.inputString.length;
    }

    return (
        <div className={"OwCharCount " + props.className}>
            {currentLength}
            {props.maxLength ? ` / ${props.maxLength}` : null}
            {props.showCharLabel ? " " : null}
            {props.showCharLabel ? <OwTranslate id={"characters"} defaultMessage={"Characters"}/> : null}
        </div>
    );
};
